export default {
	simpleVaultText: "Drag & drop files or folders here or",
	simpleVaultLabel: "browse files",
};
